export default {
	state: {
		activeCompany: ''
	},
	getters: {
		getActiveCompany: state => state.activeCompany
	},
	mutations: {
		setActiveCompany: (state, comp) => state.activeCompany = comp
	},
	actions: {
		setActiveCompany(context, comp) {
			context.commit('setActiveCompany', comp)
		}
	}
}